// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__29NVO","tabs":"LayoutWrapperSideNav_tabs__2XNGr","tab":"LayoutWrapperSideNav_tab__ioV9J"};